import { useEffect, useState, useMemo } from "react";
import api from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { Mail, Search, Copy } from "lucide-react";
import PageHeader from "@/components/PageHeader";

export default function Templates() {
  const [templates, setTemplates] = useState([]);
  const [q, setQ] = useState("");

  useEffect(() => { api.get("/content/templates").then((r) => setTemplates(r.data)).catch(() => {}); }, []);

  const results = useMemo(() => {
    const t = q.trim().toLowerCase();
    if (!t) return templates;
    return templates.filter((x) => ["category", "title", "subject", "body"]
      .some((f) => (x[f] || "").toString().toLowerCase().includes(t)));
  }, [q, templates]);

  const copy = (tpl) => {
    navigator.clipboard.writeText(`Subject: ${tpl.subject}\n\n${tpl.body}`);
    toast.success("Template copied to clipboard");
  };

  return (
    <div className="space-y-6" data-testid="templates-page">
      <PageHeader overline="Communication" title="Customer Reply Templates" icon={Mail}
        color="text-amber-600 bg-amber-50" desc="Approved email templates. Copy and personalise before sending." />

      <div className="relative max-w-2xl">
        <Search className="w-5 h-5 absolute left-4 top-1/2 -translate-y-1/2 text-slate-400" />
        <input data-testid="template-search-input" value={q} onChange={(e) => setQ(e.target.value)}
          placeholder="Search templates (e.g. proof of purchase, resolved)"
          className="w-full pl-12 pr-4 py-3.5 rounded-xl border border-slate-200 bg-white text-base focus:outline-none focus:ring-2 focus:ring-amber-500" />
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
        {results.map((t) => (
          <Card key={t.id} className="p-5 flex flex-col" data-testid={`template-${t.id}`}>
            <Badge className="bg-amber-500 w-fit mb-2">{t.category}</Badge>
            <h3 className="font-heading font-bold text-slate-900">{t.title}</h3>
            <div className="text-sm text-slate-500 mt-1">Subject: {t.subject}</div>
            <pre className="text-sm text-slate-700 mt-3 whitespace-pre-wrap font-sans bg-slate-50 rounded-lg p-3 flex-1">{t.body}</pre>
            <Button variant="outline" onClick={() => copy(t)} className="mt-3 gap-2 w-fit" data-testid={`copy-template-${t.id}`}>
              <Copy className="w-4 h-4" /> Copy
            </Button>
          </Card>
        ))}
      </div>
    </div>
  );
}
